export enum AppliedQueryType {
  Standard = 'Standard',
  Sql = 'Sql',
  Tables = 'Tables',
  OmicsSql = 'OmicsSql',
  ClinicalSql = 'ClinicalSql',
  DatahubSql = 'DatahubSql',
  DatahubAiSql = 'DatahubAiSql',
  DatahubReset = 'DatahubReset',
  Reset = 'Reset'
}

export enum CbQueryTagTypes {
  Phenotypic = 'phenotypic',
  Aggregation = 'aggregation',
  Bracket = 'bracket'
}

export enum FilterApiQueryOperators {
  And = 'AND',
  Or = 'OR',
  Not = 'NOT'
}

export enum Conditions {
  Equals = 'Equals',
  NotEquals = 'Does not equal',
  LessThan = 'Less than',
  LessOrEqualThan = 'Less or equal than',
  GreaterThan = 'Greater than',
  GreaterOrEqualThan = 'Greater or equal than',
  ContainsOneOf = 'Contains one of',
  NotContainsAnyOf = 'Does not contain any of',
  StartsWith = 'Starts with',
  NotStartsWith = 'Does not start with',
  EndsWith = 'Ends with',
  NotEndsWith = 'Does not end with',
  IsNull = 'Is null',
  IsNotNull = 'Is not null',
  IsBlank = 'Is blank',
  IsNotBlank = 'Is not blank',
  EqualsOneOf = 'Equals one of',
  NotEqualsAnyOf = 'Does not equal any of',
  Between = 'Between',
  NotBetween = 'Not between'
}

export enum ColumnDataType {
  Text = 'text',
  Integer = 'integer',
  Numeric = 'numeric',
  Date = 'date',
  Timestamp = 'timestamp',
  Boolean = 'boolean'
}
